export class DataTableRoutes {
  public static StudentList = '/api/Students/GetStudents/Datatable';
  public static ExamSubjectList = '/api/ExamSubjects/GetExamSubjectsForStudent/Datatable';
  public static ExamStudentResultList = '/api/StudentResults/GetStudentResults/Datatable';
  public static ExamReportList = '/api/ExamReports/GetExamReports/Datatable';
  public static ExamAddressList = '/api/ExamAddresses/GetExamAddresses/Datatable';
  public static ExaminerList = '/api/Examiners/GetExaminers/Datatable';
  public static UsersList = '/api/Users/GetUsersForDatatable/Datatable';
  public static TenantsList = '/api/Tenants/GetTenants/Datatable';
  public static SubjectsList = '/api/Subjects/GetSubjects/Datatable';
}
